export default __webpack_public_path__ + "static/media/logo_ortiz.df180e4e.png";